import { Component, EventEmitter, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take, takeUntil } from 'rxjs/operators';
import { UnitService } from '../../../../helper/anessa-library/anessa-library/projects/unit-library/src/public-api';
import { DeactivationDialogService } from '../../../../helper/can-deactivate/deactivation-dialog.service';
import { ProjectFinancialService } from '../../../financial/project-financial.service';
import { FinancialOpexService } from '../../../financial/financial-opex/financial-opex.service';
import { FinancialOpex, FinancialOpexType } from '../../../../models/project/financial/financial-opex.model';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-add-opex-dialog',
  templateUrl: './add-opex-dialog.component.html',
  styleUrls: [
    './add-opex-dialog.component.scss',
  ]
})
export class AddOpexDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger: string;

  @ViewChild('opexForm') opexForm: NgForm;

  opex: FinancialOpex;
  opexTypes: FinancialOpexType[] = [];
  FinancialOpexType = FinancialOpexType;

  isEdit = false;

  constructor(
    private dialogRef: MatDialogRef<AddOpexDialogComponent>,
    private unitService: UnitService,
    private dialogService: DeactivationDialogService,
    private financialService: ProjectFinancialService,
    private opexService: FinancialOpexService,
    public translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { isEdit: boolean, opex: FinancialOpex },
  ) {
    super();
    if (this.data) {
      this.isEdit = this.data.isEdit;
      if (this.isEdit) {
        this.opex = this.data.opex;
      } else {
        this.opex = new FinancialOpex();
        this.opex.name = this.translationService.get('PROJECT.FINANCIAL_OPEX.TOTAL_OPEX_AMOUNT');
        this.opex.type = FinancialOpexType.OTHER;
        const targetCurUnit = this.financialService.getCurrencyUnitById(this.opexService.getTargetUnitForTotalOpex());
        this.opex.cost.unit = targetCurUnit.id;
        this.opex.cpi.value = 0;
        this.opex.cpi.unit = '000000000000000000002201';
        this.opex.period.value = 1;
      }

      const yearUnit = this.unitService.getUnitByName('years');
      if (yearUnit) {
        if (this.opex.frequencyOfOccurrence) {
          this.opex.frequencyOfOccurrence.unit = yearUnit.id;
        }
        if (this.opex.period) {
          this.opex.period.unit = yearUnit.id;
        }
      }
    }
    this.populateOpexTypesArray();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.opexForm && this.opexForm.dirty) {
        this.dialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe((result: boolean) => {
            if (result) {
              this.dialogRef.close();
            }
          });
      } else {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  private populateOpexTypesArray() {
    for (const type of Object.keys(FinancialOpexType)) {
      this.opexTypes.push(FinancialOpexType[type]);
    }
  }

  onSaveClick() {
    this.dialogRef.close(this.opex);
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }
}
